import React from 'react'
import ReactDOM from 'react-dom'
import makeInspectable from "mobx-devtools-mst"
import App from './App'

import web3Store from "./stores/Web3Store"
import contractStore from './stores/ContractStore'
import eventStore from './stores/EventStore'
import ViewStore from './stores/ViewStore'
import AuthStore from './stores/AuthStore'
import CategoriesStore from './stores/CategoriesStore'
import UserStore from './stores/UserStore'
import TeamStore from './stores/TeamStore'
import AdminStore from './stores/AdminStore'
import WagerStore from './stores/WagerStore'
import LeagueStore from './stores/LeagueStore'
import BetSlipStore from './stores/BetSlipStore/BetSlipStore'
import CustomRouter from './stores/CustomRouter'
import CustomWagerStore from './stores/CustomWagerStore'
import { config as dotEnvConfig } from 'dotenv';

// Mobx Router
import { Provider } from "mobx-react"



// Load ENV variables
dotEnvConfig({
  path: process.env.NODE_ENV === 'production' ? '.env.prod' : '.env'
});

makeInspectable(eventStore);


const app = (
  <Provider
    web3Store={ web3Store }
    contractStore={ contractStore }
    eventStore = { eventStore }
    ViewStore = { ViewStore }
    AuthStore = { AuthStore }
    CategoriesStore = { CategoriesStore }
    UserStore = { UserStore }
    TeamStore = { TeamStore }
    AdminStore = {AdminStore}
    WagerStore = {WagerStore}
    BetSlipStore = {BetSlipStore}
    CustomRouter = {CustomRouter}
    LeagueStore = {LeagueStore}
    CustomWagerStore = {CustomWagerStore}
  >
  <App/>
  </Provider>
);
ReactDOM.render(
  app,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js